"use client";

import React, { useState, useEffect } from "react";
import { Menu } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="206173" className="flex gap-6">
        <div className="h-4 w-20 bg-muted animate-pulse rounded-sm" />
        <div className="h-4 w-20 bg-muted animate-pulse rounded-sm" />
        <div className="h-4 w-20 bg-muted animate-pulse rounded-sm" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-8">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className={cn(navigationMenuTriggerStyle(), "bg-transparent hover:bg-transparent focus:bg-transparent data-[active=true]:bg-transparent data-[state=open]:bg-transparent", "text-foreground font-default tracking-tighter text-sm font-bold uppercase transition-colors hover:text-primary px-0")}>
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-6 mt-12">
        <div className="h-6 w-32 bg-muted animate-pulse rounded-sm" />
        <div className="h-6 w-40 bg-muted animate-pulse rounded-sm" />
        <div className="h-6 w-24 bg-muted animate-pulse rounded-sm" />
      </div>;
  }
  return <div className="flex flex-col gap-8 mt-12">
      {menuItems.map((item, i) => <div key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground font-default tracking-tighter text-lg font-bold uppercase transition-colors hover:text-primary block">
            {item.label}
          </Link>
        </div>)}
    </div>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <section id="header" className={cn("sticky top-0 z-50 w-full transition-all duration-300", isScrolled ? "bg-background/80 backdrop-blur-xl border-b border-border" : "bg-background border-b border-transparent")}>
      <div className="container mx-auto px-4 md:px-8 h-20 flex items-center justify-between">
        {}
        <Link to="/" className="flex items-center shrink-0">
          
        </Link>

        {}
        <div className="hidden md:block">
          <MenuProvider menu_id="16">
            <HeaderMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <div className="md:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" aria-label="Open menu">
                <Menu className="size-6 text-foreground" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] sm:w-[400px] bg-background border-l border-border">
              <div className="mt-8">
                <Link to="/" className="flex items-center mb-8">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634045/img/legacy_delivery_services_logo.png" alt="Legacy Delivery Services" className="h-7 w-auto" />
                </Link>
                <MenuProvider menu_id="16">
                  <MobileMenuConsumer />
                </MenuProvider>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </section>;
}